import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-706ecb28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "information-blocks" }
const _hoisted_3 = { class: "all-contacts-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_information_block = _resolveComponent("information-block")!
  const _component_base_title = _resolveComponent("base-title")!
  const _component_case_contacts_list = _resolveComponent("case-contacts-list")!
  const _component_main_container_shell = _resolveComponent("main-container-shell")!

  return (_ctx.request)
    ? (_openBlock(), _createBlock(_component_main_container_shell, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.request.informationBlocks, (block) => {
                return (_openBlock(), _createBlock(_component_information_block, {
                  key: block.title,
                  block: block
                }, null, 8, ["block"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate('details.allCaseContactsTitle')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_case_contacts_list)
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}